import 'babel-polyfill';
import Vue from 'vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/style.scss';
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos'
import 'aos/dist/aos.css'


import VueSanitize from "vue-sanitize"

Vue.use(VueSanitize);
Vue.use(VueScrollTo);


router.afterEach(() => {
   const contentWrapper = document.querySelector(".v-content__wrap");
   if(contentWrapper !== null){
		contentWrapper.scrollTop = 0;
		window.scroll(0,0);
   }
})


Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
   load: {
      key: process.env.VUE_APP_GOOGLE_MAPS_APIKEY,
      libraries: ['places'],
   },
})

//Google Analytics
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  bootstrap: false,
  config: {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS,
    params: {
      'anonymize_ip': true
    }
  },
}, router)

new Vue({
   created() {
      AOS.init();
   },
   router,
   store,
   render: h => h(App)
}).$mount('#app')
